/* VD Good to Know — surfaces each product's key facts as a styled pill row
 * right under the buy buttons on product pages. It pulls straight from the
 * product's OWN description 'Features & Highlights' list (already researched,
 * accurate) so nothing is invented and it works across all products with no
 * per-product data entry. Gold/dark styling to match vapedokha.com. */
(function () {
  'use strict';
  if (window.__vdGtkInit) return;
  window.__vdGtkInit = true;

  function isProductPage() {
    return (document.body && document.body.className.indexOf('template-product') > -1) ||
           location.pathname.indexOf('/products/') > -1;
  }

  function ensureStyle() {
    if (document.getElementById('vd-gtk-style')) return;
    var st = document.createElement('style');
    st.id = 'vd-gtk-style';
    st.textContent =
      '.vd-gtk{margin:16px 0;padding:15px 18px;border:1px solid #ece6d8;border-radius:14px;background:#faf8f2;}' +
      '.vd-gtk-title{font-size:11.5px;font-weight:800;letter-spacing:.13em;text-transform:uppercase;color:#8a6d1e;margin:0 0 10px;}' +
      '.vd-gtk-pills{display:flex;flex-wrap:wrap;gap:8px;}' +
      '.vd-gtk-pill{display:inline-flex;align-items:baseline;gap:6px;padding:7px 13px;border-radius:999px;border:1px solid #e6dcc1;background:#fff;font-size:13px;line-height:1.25;}' +
      '.vd-gtk-label{color:#7c7563;}' +
      '.vd-gtk-val{font-weight:700;color:#1e1207;}';
    document.head.appendChild(st);
  }

  function findDesc() {
    var cands = document.querySelectorAll('.tab-descriptions, .rte, .product__description, [class*="description"]');
    for (var i = 0; i < cands.length; i++) {
      if (/Features|Good to Know/i.test(cands[i].innerHTML)) return cands[i];
    }
    return null;
  }

  function extractFacts(descEl) {
    var headings = descEl.querySelectorAll('h2, h3');
    var ul = null;
    for (var i = 0; i < headings.length; i++) {
      var t = (headings[i].textContent || '').toLowerCase();
      if (t.indexOf('features') > -1) {
        var n = headings[i].nextElementSibling;
        while (n && n.tagName !== 'UL') { n = n.nextElementSibling; }
        if (n) { ul = n; break; }
      }
    }
    if (!ul) return [];
    var facts = [];
    var lis = ul.querySelectorAll('li');
    for (var j = 0; j < lis.length && facts.length < 6; j++) {
      var li = lis[j];
      var strong = li.querySelector('strong');
      if (!strong) continue;
      var label = (strong.textContent || '').replace(/[:\s]+$/, '').trim();
      var value = (li.textContent || '').trim();
      if (value.indexOf(strong.textContent) === 0) value = value.slice(strong.textContent.length);
      value = value.replace(/^[:\s]+/, '').trim();
      if (label && value && value.length <= 34) facts.push({ label: label, value: value });
    }
    return facts;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function build() {
    if (!isProductPage()) return;
    if (document.querySelector('.vd-gtk')) return;
    var anchor = document.querySelector('.product-form__buttons');
    if (!anchor) return;
    var descEl = findDesc();
    if (!descEl) return;
    var facts = extractFacts(descEl);
    if (!facts.length) return;
    ensureStyle();
    var pills = '';
    for (var i = 0; i < facts.length; i++) {
      pills += '<span class="vd-gtk-pill"><span class="vd-gtk-label">' + esc(facts[i].label) +
               '</span><span class="vd-gtk-val">' + esc(facts[i].value) + '</span></span>';
    }
    var block = document.createElement('div');
    block.className = 'vd-gtk';
    block.innerHTML = '<div class="vd-gtk-title">Good to know</div><div class="vd-gtk-pills">' + pills + '</div>';
    anchor.insertAdjacentElement('afterend', block);
  }

  function start() { try { build(); } catch (e) {} }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { setTimeout(start, 500); });
})();
